
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.39 9a22.773 22.773 0 00-.921 1.96H.922v-.374c.25-.276.71-.95 1.383-2.024l2-3.21c-.407-1.224-.735-2.133-.985-2.727-.25-.594-.46-.974-.632-1.14a.828.828 0 00-.594-.25c-.177 0-.41.1-.696.304l-.32-.453C1.646.628 2.174.398 2.664.398c.516 0 .909.237 1.18.711.276.474.653 1.62 1.133 3.438L6.062 2.39c.433-.86.73-1.48.891-1.86h1.54v.375c-.256.276-.714.943-1.376 2L5.383 5.703C5.997 7.667 6.448 8.91 6.734 9.43c.287.526.61.789.97.789.176 0 .405-.104.687-.313l.32.461c-.573.464-1.083.695-1.531.695-.568 0-.992-.244-1.274-.734-.276-.49-.674-1.768-1.195-3.836L3.39 9z","fill":"currentColor"}})])
          )
        }
      }
    